import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./1st.css";

import { FaBookOpen } from "react-icons/fa";
import { MdTranslate } from "react-icons/md";
import { TbMath } from "react-icons/tb";

const content = {
  en: {
    heading: "📘 1st Standard Subjects",
    subjects: [
      {
        name: "Marathi",
        backendSubject: "Marathi",
        icon: <MdTranslate />,
      },
      {
        name: "English",
        backendSubject: "English",
        icon: <FaBookOpen />,
      },
      {
        name: "Mathematics",
        backendSubject: "Maths",
        icon: <TbMath />,
      },
    ],
  },
  mr: {
    heading: "📘 इयत्ता १ ली विषय",
    subjects: [
      {
        name: "मराठी",
        backendSubject: "Marathi",
        icon: <MdTranslate />,
      },
      {
        name: "इंग्रजी",
        backendSubject: "English",
        icon: <FaBookOpen />,
      },
      {
        name: "गणित",
        backendSubject: "Maths",
        icon: <TbMath />,
      },
    ],
  },
};

const First = ({ language = "mr" }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const selected = content[language];
  const navigate = useNavigate();

  const handleClick = (backendSubject) => {

    navigate("/quiz-details", {

      state: {

        standard: 1,

        subject: backendSubject

      }

    });

  };

  return (
    <section className="standard-section">
      <h2 className="standard-title">{selected.heading}</h2>

      <div className="subjects-container">
        {selected.subjects.map((subject, index) => (
          <div
            key={index}
            className={`subject-card subject-${index}`}
            onClick={() => handleClick(subject.backendSubject)}
          >
            <div className="subject-content">
              <div className="subject-icon">{subject.icon}</div>
              <h3>{subject.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default First;